<app-page-manage-coupons
    [hasReadPermission]="readPermission"
    [hasWritePermission]="writePermission"
    (addCouponClick)="addCoupon()"
>
</app-page-manage-coupons>
